import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  FaDesktop,
  FaKeyboard,
  FaMouse,
  FaWindows,
  FaInternetExplorer,
  FaCode,
  FaUserShield,
  FaTools,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const Basiccom = () => {
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  const roadmap = [
    {
      step: "Step 1",
      title: "Introduction to Computers",
      desc: "Learn what computers are, types, and components.",
      icon: <FaDesktop />,
    },
    {
      step: "Step 2",
      title: "Input & Output Devices",
      desc: "Keyboard, Mouse, Monitor, Printers, and more.",
      icon: <FaKeyboard />,
    },
    {
      step: "Step 3",
      title: "Operating Systems",
      desc: "Basics of Windows, Linux, macOS.",
      icon: <FaWindows />,
    },
    {
      step: "Step 4",
      title: "Internet & Browsing",
      desc: "Using browsers, search engines, and email.",
      icon: <FaInternetExplorer />,
    },
    {
      step: "Step 5",
      title: "MS Office Tools",
      desc: "Word, Excel, PowerPoint for productivity.",
      icon: <FaTools />,
    },
    {
      step: "Step 6",
      title: "Basic Coding",
      desc: "Introduction to HTML, CSS, and simple scripts.",
      icon: <FaCode />,
    },
    {
      step: "Step 7",
      title: "Cyber Security",
      desc: "Safe browsing, antivirus, and password protection.",
      icon: <FaUserShield />,
    },
  ];

  return (
    <div className="relative text-gray-100 overflow-hidden">
      {/* HEADER */}
      <header
        className="relative z-10 flex items-center justify-center text-center h-[60vh] md:h-[70vh]"
        style={{
          backgroundImage:
            "url('/assets/photo-1519389950473-47ba0277781c.AVIF')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/70"></div>
        <div className="relative z-10 px-6">
          <h1
            data-aos="fade-down"
            className="text-4xl md:text-5xl font-bold text-blue-400 mt-5"
          >
            Basic Computer Course
          </h1>
          <p
            data-aos="fade-up"
            className="text-gray-200 text-lg md:text-xl mt-3"
          >
            Learn fundamental computer skills for everyday life 💻
          </p>
          <Link to="/contact">
            <button
              data-aos="zoom-in"
              className="mt-6 px-6 py-3 bg-blue-500 text-white rounded-full font-bold shadow-md hover:bg-blue-600 transition animate-bounce"
            >
              Enroll Now
            </button>
          </Link>
        </div>
      </header>

      {/* ROADMAP */}
      <section
        className="relative py-16 px-6"
        style={{
          backgroundImage:
            "url('/assets/photo-1559028012-481c04fa702d.AVIF')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-white/85"></div>
        <div className="relative z-10 max-w-6xl mx-auto">
          <h2
            className="text-3xl md:text-4xl font-bold text-center mb-12 text-black"
            data-aos="fade-down"
          >
            Learning Roadmap
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
            {roadmap.map((item, i) => (
              <div
                key={i}
                className="relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 hover:scale-105"
                data-aos={
                  i % 3 === 0
                    ? "flip-left"
                    : i % 3 === 1
                    ? "zoom-in-up"
                    : "fade-up-right"
                }
                data-aos-delay={i * 200}
              >
                {/* Bubble Effect */}
                <div className="absolute -top-6 left-6 w-14 h-14 rounded-full bg-blue-500 text-white flex items-center justify-center text-2xl shadow-lg animate-bounce">
                  {item.icon}
                </div>

                <div className="p-6 pt-10 text-center">
                  <h3 className="text-xl font-bold text-blue-700 mb-2">
                    {item.step}: {item.title}
                  </h3>
                  <p className="text-gray-700">{item.desc}</p>

                  {/* Fun animation line */}
                  <div className="mt-4 h-1 bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 rounded-full animate-pulse"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FUTURE SCOPE */}
      <section
        className="relative py-16 px-6 bg-[url('https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=1920&q=80')] bg-cover bg-center"
        data-aos="zoom-in"
      >
        <div className="absolute inset-0 bg-black/75"></div>
        <div className="relative max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-blue-300">
            Future with Computers
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
            <div
              data-aos="flip-left"
              className="p-6 bg-gray-800 rounded-xl shadow hover:shadow-blue-400/40"
            >
              <h3 className="text-lg font-bold text-blue-400">
                Digital Skills
              </h3>
              <p className="text-gray-300 mt-2">
                Essential for every job and profession in the modern world.
              </p>
            </div>
            <div
              data-aos="flip-up"
              className="p-6 bg-gray-800 rounded-xl shadow hover:shadow-blue-400/40"
            >
              <h3 className="text-lg font-bold text-blue-400">Remote Work</h3>
              <p className="text-gray-300 mt-2">
                Computers power remote jobs, freelancing, and online education.
              </p>
            </div>
            <div
              data-aos="flip-right"
              className="p-6 bg-gray-800 rounded-xl shadow hover:shadow-blue-400/40"
            >
              <h3 className="text-lg font-bold text-blue-400">
                AI & Automation
              </h3>
              <p className="text-gray-300 mt-2">
                Basic skills are the foundation for learning future
                technologies.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer
        className="py-8 flex flex-col items-center gap-4 bg-black/80"
        data-aos="fade-up"
      >
        <Link
          to="/contact"
          data-aos="shake"
          className="px-8 py-3 bg-blue-500 text-white rounded-full font-bold shadow-md hover:bg-blue-600 transition animate-pulse"
        >
          Enroll Now
        </Link>
      </footer>
    </div>
  );
};

export default Basiccom;
